import React, { FC } from 'react';
import styled from 'styled-components';

type Props = {
  index: number;
  gridTemplateCols: string;
};

const TableRow: FC<Props> = ({ index, gridTemplateCols, children }) => {
  return (
    <SingleTableRow
      gridTemplateCols={gridTemplateCols}
      $zebra={index % 2 === 1}
    >
      {children}
    </SingleTableRow>
  );
};

export default TableRow;

const SingleTableRow = styled.div<{
  $zebra: boolean;
  gridTemplateCols: string;
}>`
  display: grid;
  position: relative;
  grid-template-columns: ${({ gridTemplateCols }) => gridTemplateCols};
  border-bottom: 1px solid var(--border);
  background: ${({ $zebra }) =>
    $zebra ? 'var(--table-row-alt)' : 'var(--table-row-base)'};
  transition: background-color 0.15s ease;
  min-width: 0;

  &:last-child {
    border-bottom: 0;
  }

  &:hover {
    background: var(--table-row-hover);
  }

  @media only screen and (max-width: 840px) {
    grid-template-columns: repeat(3, 1fr);
  }
  @media only screen and (max-width: 400px) {
    grid-template-columns: repeat(2, 1fr);
  }
`;
